import { render, staticRenderFns } from "./KorrespondenzVorlageModal.vue?vue&type=template&id=b34aff48&"
import script from "./KorrespondenzVorlageModal.vue?vue&type=script&lang=js&"
export * from "./KorrespondenzVorlageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports